<template>
  <div>
    <Form ref="discountForm" :model="discountForm" :rules="ruleValidate">
      <!-- 基本信息 -->
      <Row :gutter="10" style="margin: 1px 0px 10px 0px">
        <Col span="24">
          <Card>
            <p
              slot="title"
              style="
                line-height: 16px;
                font-size: 13px;
                color: #000;
                height: 15px;
              "
            >
              {{ $t("resourceLifecycle.basicInformation") }}
            </p>
            <!-- 客户公司 -->
            <Row>
              <Col span="24" style="font-size: 13px; margin-bottom: 5px"
                >{{ $t('Bill.ResourceOptimization.clientCompany') }}</Col
              >
              <Col span="12">
                <FormItem label="" prop="customerCompany">
                  <Select
                    v-model="discountForm.customerCompany"
                    filterable
                    :transfer="true"
                    placeholder=""
                    style="width: 70%"
                    @on-change="getDiscountConfig()"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in customerCompanyList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>

            <!-- 是否特殊折扣 -->
            <Row>
              <Col span="24" style="font-size: 13px; margin-bottom: 5px"
                >{{ $t('Bill.ResourceOptimization.specialDiscountOrNot') }}</Col
              >
              <Col span="12">
                <FormItem label="" prop="specialDiscount">
                  <Select
                    v-model="discountForm.specialDiscount"
                    filterable
                    :transfer="true"
                    placeholder=""
                    style="width: 70%"
                    @on-change="getspecialDiscount()"
                  >
                    <Option
                      :value="item.key"
                      v-for="(item, index) in specialDiscountList"
                      :key="index"
                      >{{ item.value }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>

            <!-- 基本折扣 -->
            <div v-if="discountForm.specialDiscount == 'true'">
              <!--    该字段暂时用不到,先不显示    -->
              <Row v-if="false">
                <Col span="24" style="font-size: 13px; margin-bottom: 5px"
                  >{{ $t('Bill.ResourceOptimization.basicDiscountOff') }}</Col
                >
                <Col span="2">
                  <FormItem label="" prop="basicDiscount">
                    <InputNumber
                      :max="100"
                      v-model="discountForm.basicDiscount"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')"
                      placeholder=""
                      style="width: 70%"
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem label="">
                    <Table
                      :no-data-text="$t('common.noData')"
                      :columns="tableColumns"
                      :data="tableData"
                      border
                    >
                      <!-- 动态循环的tag -->
                      <template
                        slot-scope="{ row, column, index }"
                        :slot="item.slot"
                        v-for="(item, index) in tableColumns"
                      >
                        <!-- 编辑单元格 -->
                        <InputNumber
                          v-model="tableData[index][column.slot]"
                          v-if="
                            selectedCell.rowIndex === index &&
                              selectedCell.columnIndex === column.slot
                          "
                          @on-enter="initSelectedCell()"
                          type="number"
                        />
                        <!-- 显示内容 -->
                        <div v-else>
                          <div
                            @click="editCellData(row, column, index)"
                            style="cursor: pointer"
                          >
                            {{ row[item.slot] }}
                          </div>
                        </div>
                      </template>
                    </Table>
                  </FormItem>
                </Col>
              </Row>
            </div>
            <FormItem>
              <!-- 更新 -->
              <Button
                type="primary"
                :loading="loading"
                v-hasPermission="[
                  'ebilling:discountConfiguration:updateDiscountConfig'
                ]"
                @click="handleSubmit(discountForm)"
                >{{$t('tag.update') }}</Button
              >
            </FormItem>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  name: "DiscountConfiguration",
  data() {
    return {
      loading: false,
      selectedCell: {
        columnIndex: "",
        rowIndex: ""
      },
      customerCompanyList: [],
      specialDiscountList: [
        {
          key: "true",
          value: this.$t('common.yes')
        },
        {
          key: "false",
          value: this.$t('common.no')
        }
      ],
      discountForm: {
        customerCompany: "",
        basicDiscount: null,
        specialDiscount: ""
      },
      ruleValidate: {
        customerCompany: [
          {
            required: true,
            message: this.$t('Bill.ResourceOptimization.pleaseSelectClientCompany'),
            trigger: "change",
            type: "number"
          }
        ],
        basicDiscount: [
          {
            required: true,
            message: this.$t('Bill.ResourceOptimization.pleaseInputBasicDiscount'),
            trigger: "blur",
            type: "number"
          }
        ],
        specialDiscount: [
          {
            required: true,
            message: this.$t('Bill.ResourceOptimization.pleaseSelectSpecialDiscount'),
            trigger: "change",
            type: "string"
          }
        ]
      },
      tableColumns: [
        {
          title: "OD VMs(no SUD)¹",
          key: "odVmsNoSud",
          slot: "odVmsNoSud"
        },
        {
          title: "CUD VMs 1-Year",
          key: "cudVmsOneYear",
          slot: "cudVmsOneYear"
        },
        {
          title: "CUD VMs 3-Year",
          key: "cudVmsThreeYear",
          slot: "cudVmsThreeYear"
        },
        {
          title: "Standard Storage",
          key: "standardStorage",
          slot: "standardStorage"
        },
        {
          title: "Big Query",
          key: "bigQuery",
          slot: "bigQuery"
        },
        {
          title: "Network Egress",
          key: "networkEgress",
          slot: "networkEgress"
        },
        {
          title: "Cloud SQL",
          key: "cloudSql",
          slot: "cloudSql"
        },
        {
          title: "Standard AI platform",
          key: "standardAiPlatform",
          slot: "standardAiPlatform"
        },
        {
          title: "Support Base Fee⁴",
          key: "supportBaseFee",
          slot: "supportBaseFee"
        },
        {
          title: "Anthos",
          key: "anthos",
          slot: "anthos"
        },
        {
          title: "Marketplace & 3rd Party",
          key: "marketplaceThirdParty",
          slot: "marketplaceThirdParty"
        },
        {
          title: "Workspace Subscription³",
          key: "workspaceSubscription",
          slot: "workspaceSubscription"
        }
      ],
      tableData: []
    };
  },

  mounted: function() {
    this.getCompanyDropDownBox();
  },
  methods: {
    // 获取公司下拉列表
    getCompanyDropDownBox: function() {
      this.$api.company.getCompanyDropDownBox().then(res => {
        this.customerCompanyList = res.data;
      });
    },
    // 获取公司折扣信息
    getDiscountConfig: function() {
      this.tableData = [];
      this.$api.gcpDiscount
        .selectDiscountConfig("companyId", this.discountForm.customerCompany)
        .then(res => {
          if (res.data.discount == null || res.data.discount == false) {
            this.discountForm.basicDiscount = null;
            this.discountForm.specialDiscount = this.specialDiscountList[1].key;
            res.data.odVmsNoSud = 0;
            res.data.cudVmsOneYear = 0;
            res.data.cudVmsThreeYear = 0;
            res.data.standardStorage = 0;
            res.data.bigQuery = 0;
            res.data.networkEgress = 0;
            res.data.cloudSql = 0;
            res.data.standardAiPlatform = 0;
            res.data.supportBaseFee = 0;
            res.data.anthos = 0;
            res.data.marketplaceThirdParty = 0;
            res.data.workspaceSubscription = 0;
            this.tableData.push(res.data);
          } else {
            this.discountForm.basicDiscount = res.data.baseDiscount;
            this.discountForm.specialDiscount = this.specialDiscountList[0].key;
            this.tableData.push(res.data);
          }
        });
    },
    //更改下拉特殊折扣事件
    getspecialDiscount() {
      if (this.discountForm.specialDiscount == "true") {
        // console.log(true);
      } else {
        //console.log(false);
      }
    },
    /******************** 编辑单元格 *****************************/
    initSelectedCell: function() {
      // 单元格数据不输入给默认值
      let columnData = this.selectedCell.columnIndex;
      let rowData = this.selectedCell.rowIndex;
      if (
        this.tableData[rowData][columnData] == null ||
        this.tableData[rowData][columnData] == ""
      ) {
        this.tableData[rowData][columnData] = 0;
      }
      this.selectedCell.rowIndex = "";
      this.selectedCell.columnIndex = "";
    },
    editCellData: function(row, column, index) {
      this.selectedCell.rowIndex = index;
      this.selectedCell.columnIndex = column.slot;
    },
    /*********************更新*********************************/
    handleSubmit: function(name) {
      this.$refs.discountForm.validate(valid => {
        if (valid) {
          // 提交
          this.loading = true;
          console.log(
            this.discountForm.specialDiscount,
            "this.discountForm.specialDiscount"
          );
          this.$api.gcpDiscount
            .updateDiscountConfig({
              companyId: this.discountForm.customerCompany,
              id: this.tableData[0].id,
              isDiscount: this.discountForm.specialDiscount,
              baseDiscount: this.discountForm.basicDiscount,
              odVmsNoSud: this.tableData[0].odVmsNoSud,
              cudVmsOneYear: this.tableData[0].cudVmsOneYear,
              cudVmsThreeYear: this.tableData[0].cudVmsThreeYear,
              standardStorage: this.tableData[0].standardStorage,
              bigQuery: this.tableData[0].bigQuery,
              networkEgress: this.tableData[0].networkEgress,
              cloudSql: this.tableData[0].cloudSql,
              standardAiPlatform: this.tableData[0].standardAiPlatform,
              supportBaseFee: this.tableData[0].supportBaseFee,
              anthos: this.tableData[0].anthos,
              marketplaceThirdParty: this.tableData[0].marketplaceThirdParty,
              workspaceSubscription: this.tableData[0].workspaceSubscription
            })
            .then(res => {
              //this.$refs[name].resetFields();
              this.loading = false;
              /* this.$nextTick(() => {
                                this.loading = true;
                            }); */
              this.$Message.success(this.$t('common.updateSuccess'));
              // this.$router.push({path: '/approvalTask', query: {t: Date.now()}});
            });
        } else {
          this.loading = false;
          this.$Message.error(this.$t('common.updateFail'));
        }
      });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/ebilling/gcp/discount_configuration/DiscountConfiguration.vue